export default __webpack_public_path__ + "static/media/support.1476cae2.png";